import type { Export } from '../../types';

export default (exports: Export[]) => {
  exports.push({ id: 'presentingComplaint', value: 'Other problems' });
  exports.push({ id: 'snomedCode', value: '183093006, Had a chat to patient' });
  exports.push({
    id: 'diagnosis.options',
    value: [
      'Cardiovascular problem',
      'Respiratory problem',
      'Gastrointestinal problem',
      'Neurological problem',
      'Endocrine problem',
      'Eye problem',
      'ENT problem',
      'Musculoskeletal problem',
      'Dermatology problem',
      'Renal / Urinary problem',
      'Gynaecological / Genital problem',
      'Male urological / Genital problem',
      'Mental illness',
      'Other',
    ],
  });
  exports.push({
    id: 'investigationsRequested.options',
    value: ['None'],
  });
  exports.push({
    id: 'prescribed.options',
    value: ['Prescribed medication'],
  });
  exports.push({
    id: 'outcome.options',
    value: [
      'Self-care',
      'Medication prescribed and advice provided',
      'Investigations requested',
      'Routine GP appointment',
      'Urgent GP appointment',
    ],
  });
  exports.push({
    id: 'actionNeeded.options',
    value: ['None'],
  });
};
